// --- smooth scroll --------------

// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);

// --- smooth scroll --------------


// ============ Header cart Total Price Start ============

// Select the element that displays the cart total
function formatINR(amount) {
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  }).format(amount / 100);
}
let lastCartTotal = null;
document.addEventListener("DOMContentLoaded", () => {
  const originalFetch = window.fetch;
 
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
 
    if (
      args[0].includes("/cart") ||
      args[0].includes("/cart/add.js") ||
      args[0].includes("/cart/change.js") ||
      args[0].includes("/cart/update.js")
    ) {
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          if (cart.total_price !== lastCartTotal) {
            lastCartTotal = cart.total_price;
            if(lastCartTotal=='0'){
            document.querySelector(".header-cart-total").innerText = `RS. 0.00`; 
            }
            else{
            document.querySelector(".header-cart-total").innerText = `RS. ${formatINR(lastCartTotal)}`;
            }
          }
        });
    }
 
    return response;
  };
});

// ============ Header cart Total Price R ============


// --header cart totel new code----28-11-25-----

// function formatINR(amount) {
//   return new Intl.NumberFormat("en-IN", {
//     maximumFractionDigits: 0,
//   }).format(amount / 100);
// } 
// setInterval(() => {
//     const bubblecount = document.querySelector("#cart-icon-bubble .cart-count-bubble span[aria-hidden='true']")
//     const cartTotal = document.querySelector(".header-cart-total");
//     if(bubblecount){
//       fetch("/cart.js")
//         .then((res) => res.json())
//         .then((cart) => {
//           let cartCount = cart.item_count;
//           let cPrice = cart.total_price;
//           if(cartCount != bubblecount.textContent || cartTotal.getAttribute("data-price")!=cPrice){
//             cartTotal.textContent =`RS. ${cPrice==0 ? "0.00" : formatINR(cart.total_price)}` ;
//             bubblecount.textContent = cartCount;
//             updateCartDrawerUI()
//           }
//       });
//     }
//   }, 1000);
//   async function updateCartDrawerUI() {
//         try {
//           const data = await (await fetch("/?sections=cart-drawer,cart-icon-bubble")).json()
//           , newCartDrawerHTML = data["cart-drawer"]
//           , newCartDrawer = new DOMParser().parseFromString(newCartDrawerHTML, "text/html").querySelector("cart-drawer")
//           , currentCartDrawer = document.querySelector("cart-drawer");
//           newCartDrawer && currentCartDrawer && (currentCartDrawer.classList.remove("is-empty"),
//           currentCartDrawer.innerHTML = newCartDrawer.innerHTML,
//           document.querySelector("#CartDrawer-Overlay")?.addEventListener("click", () => {
//             document.querySelector("cart-drawer.drawer")?.classList.remove("active")
//           }
//         ));
//         } catch (err) {
//             console.error("Failed to update cart drawer and bubble:", err)
//         }
//     }

// --header cart totel new code----28-11-25-----





// --------- Draggable Scroll JS ---------
function enableLeftClickDragScroll(container) {
  if (!container) return;

  let isDragging = false;
  let dragStarted = false;
  let startX = 0;
  let scrollStart = 0;
  const dragThreshold = 5;
  const scrollSpeedFactor = 0.9; // Lower values = slower scrolling

  container.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    isDragging = true;
    dragStarted = false;
    startX = e.pageX;
    scrollStart = container.scrollLeft;
    container.classList.add("is-dragging");
    e.preventDefault();
  });

  container.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    const deltaX = e.pageX - startX;

    if (!dragStarted && Math.abs(deltaX) > dragThreshold) {
      dragStarted = true;
    }

    if (dragStarted) {
      container.scrollLeft = scrollStart - deltaX * scrollSpeedFactor;
    }
  });

  container.addEventListener("mouseup", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("mouseleave", () => {
    isDragging = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("click", (e) => {
    if (dragStarted) {
      e.preventDefault();
      e.stopPropagation();
      dragStarted = false;
    }
  });

  container.classList.add("is-draggable");
}


function waitForElementAndInit(selector) {
  // Initialize any that already exist
  document.querySelectorAll(selector).forEach(el => {
    if (!el._dragInitialized) {
      enableLeftClickDragScroll(el);
      el._dragInitialized = true;
    }
  });

  // Observe future additions
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches(selector) && !node._dragInitialized) {
          enableLeftClickDragScroll(node);
          node._dragInitialized = true;
        }

        // Check descendants too
        node.querySelectorAll?.(selector)?.forEach((el) => {
          if (!el._dragInitialized) {
            enableLeftClickDragScroll(el);
            el._dragInitialized = true;
          }
        });
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // ===============================================
  // ADD CLASS OR ID OF CONTAINER TO SCROLL [ DEV-03 ]
  // ===============================================
  const scrollSelectors = [".product-grid",".predictive-search__results-list"];

  scrollSelectors.forEach(selector => {
    waitForElementAndInit(selector);
  });
});

// --------- Draggable JS ---------


// --- Header BG start [DEV-03] --------------

document.addEventListener("DOMContentLoaded", () => {
  const mainHeader = document.querySelector(".main-header");

  document.addEventListener("scroll", () => {
    if (window.scrollY > mainHeader.offsetHeight) {
      mainHeader.classList.add("active");
    } else {
      mainHeader.classList.remove("active");
    }
  });
});

// --- Header BG end --------------


// ------------ mobile menu x design -----

// const toggleBtn = document.querySelector('.toggle-btn-d');
// const mobMenuBox = document.querySelector('.mob-menu-box');

// toggleBtn.addEventListener('click', () => {
//   toggleBtn.classList.toggle('active');
//   mobMenuBox.classList.toggle('active');
// });

// ------------ mobile menu x design -----


// -------- marquee close btn mobile -------
function closemq() {
  const marqueecl = document.querySelector(".mob-marquee-span");
  marqueecl.classList.toggle("close");
}

// -------- marquee close btn mobile -------


// ---------- search box ----

  // function clickmesearch() {
  //   const boxes = document.querySelectorAll('.my-search-box');
  //   boxes.forEach(box => {
  //     box.classList.toggle('active');
  //   });
  // }


// ---------- search box ----

// Search toggle function
function clickmesearch() {
    const boxes = document.querySelectorAll('.my-search-box');
    const toggleBtn = document.querySelector('.toggle-btn-d');
    const mobMenuBox = document.querySelector('.mob-menu-box');
    
    boxes.forEach(box => {
        box.classList.toggle('active');
    });
    
    // Close mobile menu when search is opened
    const isSearchActive = document.querySelector('.my-search-box.active');
    if (isSearchActive) {
        toggleBtn.classList.remove('active');
        mobMenuBox.classList.remove('active');
    }
}

// Mobile menu toggle
const toggleBtn = document.querySelector('.toggle-btn-d');
const mobMenuBox = document.querySelector('.mob-menu-box');

toggleBtn.addEventListener('click', () => {
    toggleBtn.classList.toggle('active');
    mobMenuBox.classList.toggle('active');
    
    // Close search when mobile menu is opened
    const isMenuActive = mobMenuBox.classList.contains('active');
    if (isMenuActive) {
        const boxes = document.querySelectorAll('.my-search-box');
        boxes.forEach(box => {
            box.classList.remove('active');
        });
    }
});


// ---- for search --------
document.querySelector("details").setAttribute("open", "true");
// ---- for search --------

// ============ PDP Description Read more ============ 

document.addEventListener('DOMContentLoaded', () => {
  try{
  const paragraphs = document.querySelectorAll('.expandable-text');
paragraphs.forEach(paragraph => {
    const words = paragraph.innerText.split(' ');

    if (words.length > 30) {
      const visibleText = words.slice(0, 50).join(' ');
      const hiddenText = words.slice(50).join(' ');

      paragraph.innerHTML = `
        ${visibleText}<span class="dots">...</span>
        <span class="more" style="display:none;"> ${hiddenText}</span>
        <button class="read-more-btn" type="button" style="opacity: 1 !important;">Read More</button>
      `;

      const btn = paragraph.querySelector('.read-more-btn');
      const dots = paragraph.querySelector('.dots');
      const more = paragraph.querySelector('.more');

      btn.addEventListener('click', () => {
        if (paragraph.classList.contains('expanded')) {
          paragraph.classList.remove('expanded');
          more.style.display = 'none';
          dots.style.display = 'inline';
          btn.innerText = 'Read More';
        } else {
          paragraph.classList.add('expanded');
          more.style.display = 'inline';
          dots.style.display = 'none';
          btn.innerText = 'Read Less';
        }
      });
    }
  });
}catch(err){

}finally{
  document.querySelector(".product__info-wrapper").setAttribute("style","display:flex")
  setTimeout(()=>{
    document.querySelector(".product__media-wrapper slider-component").setAttribute("style","opacity:1 !important")
  },300)
}
});

//  ============ PDP Description Read more ============ 




// document.addEventListener("DOMContentLoaded", () => {
  
//   // Run only on desktop
//   const isDesktop = window.innerWidth >= 1024;
//   if (!isDesktop) return;

//   const sliders = [
//     document.querySelector(".option1-data .carousel"),
//     document.querySelector(".collection .slider-mobile-gutter .grid")
//   ];

//   sliders.forEach((scrollContainer, index) => {
//     if (!scrollContainer) return;

//     // Prevent multiple initialization
//     const initKey = `infiniteScrollInit_${index}`;
//     if (window[initKey]) return;
//     window[initKey] = true;

//     // Duplicate items ONLY on desktop
//     const items = Array.from(scrollContainer.children);
//     items.forEach(el => {
//       const clone = el.cloneNode(true);
//       clone.classList.add("clone");
//       scrollContainer.appendChild(clone);
//     });

//     let speed = 2;
//     let interval = null;
//     let isHovered = false;

//     function startScroll() {
//       if (interval) return;

//       interval = setInterval(() => {
//         if (isHovered) return;

//         scrollContainer.scrollLeft += speed;

//         if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
//           scrollContainer.scrollLeft -= scrollContainer.scrollWidth / 2;
//         }
//       }, 16);
//     }

//     function stopScroll() {
//       clearInterval(interval);
//       interval = null;
//     }

//     // Pause on hover (desktop only)
//     scrollContainer.addEventListener("mouseenter", () => {
//       isHovered = true;
//       stopScroll();
//     });

//     scrollContainer.addEventListener("mouseleave", () => {
//       isHovered = false;
//       startScroll();
//     });

//     startScroll();
//   });

// });


 function toggleAccordion(element) {
    const block = element.parentElement;
    const content = block.querySelector('.pdp-accordian-content');
    const icon = element.querySelector('.accordion-icon');

    const allBlocks = document.querySelectorAll('.pdp-accordian-block');

    allBlocks.forEach((otherBlock) => {
      if (otherBlock !== block) {
        const otherContent = otherBlock.querySelector('.pdp-accordian-content');
        const otherIcon = otherBlock.querySelector('.accordion-icon');
        otherContent.style.maxHeight = null;
        otherIcon.textContent = '+';
        otherBlock.classList.remove('active');
      }
    });

    block.classList.toggle('active');

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      icon.textContent = '+';
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      icon.textContent = '−';
    }
  }




/* =========================================================
   scroll-img
   ========================================================= */

const initializedGalleries = new WeakSet();

let galleryObserver = null;
let observerTimer = null;
let galleryInitDone = false;

function getGallery(el) {

    if (!el) {
        return null;
    }

    const mediaWrapper =
        el.closest(".card__inner");

    if (!mediaWrapper) {
        return null;
    }

    const galleryWrapper =
        mediaWrapper.querySelector(".card-img-ul");

    const dotsWrapper =
        mediaWrapper.querySelector(".card-img-dots");

    if (!galleryWrapper) {
        return null;
    }

    const slides =
        galleryWrapper.querySelectorAll(":scope > li");

    if (!slides.length) {
        return null;
    }

    return {
        mediaWrapper: mediaWrapper,
        galleryWrapper: galleryWrapper,
        dotsWrapper: dotsWrapper,
        slides: slides
    };
}

function getCurrentIndex(gallery) {

    if (!gallery) {
        return 0;
    }

    const {
        galleryWrapper,
        slides
    } = gallery;

    if (!galleryWrapper || !slides.length) {
        return 0;
    }

    const scrollLeft =
        galleryWrapper.scrollLeft;

    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {

        if (!slide) {
            return;
        }

        const distance =
            Math.abs(
                slide.offsetLeft - scrollLeft
            );

        if (distance < closestDistance) {

            closestDistance = distance;
            closestIndex = index;

        }

    });

    return closestIndex;
}

function updateGallery(gallery, index) {

    if (!gallery) {
        return;
    }

    const {
        mediaWrapper,
        dotsWrapper,
        slides
    } = gallery;

    const total =
        slides.length;

    if (!total) {
        return;
    }

    index =
        Math.max(
            0,
            Math.min(
                index,
                total - 1
            )
        );

    if (dotsWrapper) {

        dotsWrapper
            .querySelectorAll("li")
            .forEach((dot, dotIndex) => {

                dot.classList.toggle(
                    "active",
                    dotIndex === index
                );

                const button =
                    dot.querySelector("button");

                if (button) {

                    button.classList.toggle(
                        "active",
                        dotIndex === index
                    );

                    button.setAttribute(
                        "aria-current",
                        dotIndex === index
                            ? "true"
                            : "false"
                    );

                }

            });

    }

    if (mediaWrapper) {

        const leftButton =
            mediaWrapper.querySelector(
                ".ci-left-btn"
            );

        if (leftButton) {

            const isFirst =
                index === 0;

            leftButton.style.opacity =
                isFirst ? "0" : "1";

            leftButton.style.pointerEvents =
                isFirst ? "none" : "auto";

        }

        const rightButton =
            mediaWrapper.querySelector(
                ".ci-right-btn"
            );

        if (rightButton) {

            const isLast =
                index === total - 1;

            rightButton.style.opacity =
                isLast ? "0" : "1";

            rightButton.style.pointerEvents =
                isLast ? "none" : "auto";

        }

    }

}

function goToSlide(gallery, index) {

    if (!gallery) {
        return;
    }

    const {
        galleryWrapper,
        slides
    } = gallery;

    if (!galleryWrapper || !slides.length) {
        return;
    }

    index =
        Math.max(
            0,
            Math.min(
                index,
                slides.length - 1
            )
        );

    const targetSlide =
        slides[index];

    if (!targetSlide) {
        return;
    }

    galleryWrapper.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: "smooth"
    });

    updateGallery(
        gallery,
        index
    );
}

function snapScrollLeft(button) {

    const gallery =
        getGallery(button);

    if (!gallery) {
        return;
    }

    const {
        slides
    } = gallery;

    const currentIndex =
        getCurrentIndex(gallery);

    if (currentIndex <= 0) {

        goToSlide(
            gallery,
            0
        );

        return;
    }

    goToSlide(
        gallery,
        currentIndex - 1
    );
}

function snapScrollRight(button) {

    const gallery =
        getGallery(button);

    if (!gallery) {
        return;
    }

    const {
        slides
    } = gallery;

    const currentIndex =
        getCurrentIndex(gallery);

    const lastIndex =
        slides.length - 1;

    if (currentIndex >= lastIndex) {

        goToSlide(
            gallery,
            lastIndex
        );

        return;
    }

    goToSlide(
        gallery,
        currentIndex + 1
    );
}

function addScrollEnd(
    element,
    callback,
    delay = 120
) {

    if (!element) {
        return;
    }

    if (
        element.dataset.galleryScrollBound ===
        "true"
    ) {
        return;
    }

    element.dataset.galleryScrollBound =
        "true";


    let timer = null;


    element.addEventListener(
        "scroll",
        function () {

            clearTimeout(timer);

            timer =
                setTimeout(
                    function () {

                        if (
                            typeof callback ===
                            "function"
                        ) {

                            callback();

                        }

                    },
                    delay
                );

        },
        {
            passive: true
        }
    );

}

function addDotClick(gallery) {

    if (!gallery) {
        return;
    }

    const {
        dotsWrapper,
        slides
    } = gallery;

    if (!dotsWrapper || !slides.length) {
        return;
    }

    const dots =
        dotsWrapper.querySelectorAll(
            ":scope > li"
        );


    if (!dots.length) {
        return;
    }


    dots.forEach(
        function (dot, index) {

            if (!dot) {
                return;
            }

            if (
                dot.dataset.galleryDotBound ===
                "true"
            ) {
                return;
            }

            dot.dataset.galleryDotBound =
                "true";


            dot.addEventListener(
                "click",
                function (event) {

                    event.preventDefault();
                    event.stopPropagation();

                    if (
                        index < 0 ||
                        index >= slides.length
                    ) {
                        return;
                    }

                    goToSlide(
                        gallery,
                        index
                    );

                }
            );

        }
    );

}

function initializeGallery(galleryElement) {

    if (!galleryElement) {
        return;
    }

    if (
        initializedGalleries.has(
            galleryElement
        )
    ) {
        return;
    }


    const gallery =
        getGallery(galleryElement);

    if (!gallery) {
        return;
    }

    initializedGalleries.add(
        galleryElement
    );

    const currentIndex =
        getCurrentIndex(gallery);

    updateGallery(
        gallery,
        currentIndex
    );

    addDotClick(
        gallery
    );

    addScrollEnd(
        galleryElement,
        function () {

            const index =
                getCurrentIndex(
                    gallery
                );

            updateGallery(
                gallery,
                index
            );

        }
    );

}

function connectDotsChange() {

    document
        .querySelectorAll(
            ".card-img-ul"
        )
        .forEach(
            function (galleryElement) {

                initializeGallery(
                    galleryElement
                );

            }
        );

}

function startGalleryObserver() {

    if (galleryObserver) {
        return;
    }


    const target =
        document.body;

    if (!target) {
        return;
    }


    galleryObserver =
        new MutationObserver(
            function () {

                clearTimeout(
                    observerTimer
                );


                observerTimer =
                    setTimeout(
                        function () {

                            connectDotsChange();

                        },
                        150
                    );

            }
        );


    galleryObserver.observe(
        target,
        {
            childList: true,
            subtree: true
        }
    );

}

function initCardGalleries() {

    if (galleryInitDone) {
        return;
    }

    galleryInitDone = true;

    connectDotsChange();

    startGalleryObserver();

}

if (
    document.readyState ===
    "loading"
) {

    document.addEventListener(
        "DOMContentLoaded",
        initCardGalleries,
        {
            once: true
        }
    );

} else {

    initCardGalleries();

}
